import { FC } from "react"
import { createUseStyles } from "react-jss"

import colors from "../../styles/colors"
import { mediaQueries } from "../../styles/breakpoints"

const useStyles = createUseStyles({
  wrapper: {
    lineHeight: "1.625",
    fontSize: "1.125rem",
    "& h3": {
      margin: "40px 0 24px",
      fontSize: "1.875rem",
      lineHeight: "2.5rem",
      textAlign: "center",
      color: colors.blue7,
      fontFamily: "var(--font-montserrat), sans-serif",
      [mediaQueries.largeMobile]: {
        fontSize: "2.25rem",
      },
    },
    "& h4": {
      fontFamily: "var(--font-montserrat), sans-serif",
      margin: "30px 0 10px",
      fontSize: "1.875rem",
    },
  },
})
export interface IPetAreaTransporter {
  areaTransporters?: string
}
const PetAreaTransporter: FC<IPetAreaTransporter> = ({ areaTransporters }) => {
  const classes = useStyles()

  if (!areaTransporters) {
    return null
  }
  return (
    <section
      id="area-transporter-section"
      className="relative w-full page-padding flex flex-col md:flex-row gap-x-8 lg:gap-x-16 xl:gap-x-24"
    >
      <div
        className={classes.wrapper}
        id="area-transporter"
        dangerouslySetInnerHTML={{
          __html: areaTransporters,
        }}
      />
    </section>
  )
}
export default PetAreaTransporter
